module.exports = __webpack_public_path__ + "img/VERS1.415fe829.png";